import React, { useEffect, useState } from 'react';
import { isEmpty, isEqual } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

import { ServiceCatalogItem } from '@nile/types';
import { InlineEdit, Row, DisabledTag } from '@nile/components';

import TaxSelector from '@nile/banyan/src/Pages/ServiceCatalogNew/TaxSelector';

function TaxCell(props) {
  const { cell } = props;
  const { actions, editable } = cell?.column;
  const rowData: ServiceCatalogItem = cell?.row?.original;
  const isEditable =
    !!rowData?.taxable && editable && rowData?.status !== 'INACTIVE';

  const [salesTax, setSalesTax] = useState(rowData?.salesTax);

  useEffect(() => {
    setSalesTax(rowData?.salesTax || null);
  }, [rowData?.salesTax]);

  return (
    <div className="fx fg1" key={rowData?.itemId}>
      <InlineEdit
        showProgress
        saveOnEnter
        hideActionButtons
        editable={isEditable}
        defaultValue={salesTax?.taxId}
        autoSave
        editView={({ updateFieldState }) => {
          return (
            <div className="fg1 fx actr w150p">
              <TaxSelector
                defaultMenuIsOpen
                salesTax={salesTax}
                onChange={(selectedTaxRate) => {
                  setSalesTax(selectedTaxRate);
                  updateFieldState(selectedTaxRate);
                }}
              />
            </div>
          );
        }}
        readView={() => {
          return (
            <div className={`ellipsis ${isEditable ? 'editable-cell' : ''} p8`}>
              <div className="fg1 fx actr g5">
                {!isEmpty(salesTax) ? (
                  <Row className="actr" gap={5}>
                    <TaxSelector salesTax={salesTax} mode="view" />
                  </Row>
                ) : (
                  <DisabledTag>
                    <FormattedMessage id="app.noData.message" />
                  </DisabledTag>
                )}
                {isEditable && (
                  <span className="fx mlauto action-button">
                    <SVGIcon name="Edit" />
                  </span>
                )}
              </div>
            </div>
          );
        }}
        onConfirm={(val, callback) => {
          const inputObject = {
            itemId: rowData?.itemId,
            salesTax: null
          };

          if (val && val?.taxId) {
            inputObject.salesTax = {
              taxId: val?.taxId
            };
          }

          if (actions?.save) {
            actions
              .save(inputObject)
              .then(() => {
                callback('success');
              })
              .catch(() => {
                setSalesTax(rowData?.salesTax);
                callback('error');
              });
          } else {
            callback('success');
          }
        }}
      />
    </div>
  );
}

export default TaxCell;
